<template>
  <div></div>
</template>

<script>

import { mapActions } from 'vuex'

export default {

  methods: {

    ...mapActions('user', ['doLogoutAll']),

    async logout () {
      try {
        await this.doLogoutAll()
      } catch (error) {
        console.log(error)
        alert('Somehting Went Wrong !')
      } finally {
        this.$root.$bvToast.toast('Signed Out All Devices', {
            title: 'Success',
            autoHideDelay: 3000,
            variant: 'success',
          })
        this.$router.push({ name: 'login' })
      }
    }
  },

  mounted () {
    this.logout()
  }

}

</script>
